import { Link } from "react-router-dom";
import { profile } from "../data/content";

export default function Home() {
  return (
    <div className="page home">
      <section className="hero">
        <div className="hero-copy">
          <p className="hero-brand fade-up">{profile.name}</p>
          <h1 className="hero-degree fade-up delay-1">{profile.degree}</h1>
          <p className="hero-tagline fade-up delay-2">{profile.tagline}</p>
          <div className="hero-actions fade-up delay-3">
            <Link to="/cv" className="btn btn-primary">
              View CV
            </Link>
            <Link to="/publications" className="btn btn-ghost">
              Publications
            </Link>
          </div>
        </div>

        <div className="hero-portrait fade-up delay-2">
          <div className="portrait-ring">
            <img
              src={profile.headshot}
              alt={`${profile.name} headshot`}
              className="portrait-img"
            />
          </div>
          <p className="portrait-meta">{profile.affiliation}</p>
        </div>
      </section>

      <section className="about-section">
        <h2 className="section-title">About</h2>
        <div className="about-prose">
          {profile.about.split("\n\n").map((para) => (
            <p key={para.slice(0, 24)}>{para}</p>
          ))}
        </div>
      </section>
    </div>
  );
}
